import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { StagingPayrollRecord } from 'src/app/models/payrollRecord';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { ImportService } from 'src/app/shared/services/payroll/import.service';
import { Utility } from 'src/app/shared/utility';

@Component({
  selector: 'app-payroll-record-add-edit-form',
  templateUrl: './payroll-record-add-edit-form.component.html',
  styleUrls: ['./payroll-record-add-edit-form.component.css']
})
export class PayrollRecordAddEditFormComponent implements OnInit {
  recordErrors: any;
  recordIssues: any;
  defaultState: any;
  defaultLocation: any;
  defaultSystem: any = 1;
  popUpIssues: any;
  recordId: any;
  states: any[];
  importId: number;
  invalidAAC: any;
  invalidAEC: any;
  invalidContribution: any;
  invalidPPBaseSalary: any;
  invalidHoursWork: any;
  invalidStandardHours: any;
  invalidFTRange: any;
  invalidFT: any;
  errorAndIssueMsg: any;
  continueMsg: any;
  pped: string = new Date().toLocaleDateString();
  validationSettings: any[];
  enrollmentDateCutoff: Date = new Date();
  defaultItem: { name: string; id: string } = {
    name: 'Select a location...',
    id: ''
  };
  defaultSysItem: { name: string; id: string } = {
    name: 'Select a system...',
    id: ''
  };
  ssnMask = '000-00-0000';
  zipMask = '00000';
  zip4Mask = '0000';
  charLimit = 6;
  contrCharLimit = 7;
  baseSalCharLimit = 9;
  min = 0.0;
  maxHW = 999;
  maxSH = 999;
  maxPBS = 999999;
  maxAEC = 999999;
  isProcessing = false;
  active = false;
  isNewRecord = false;
  isErr = false;
  isIssue = false;
  displaySubmitPopUp = false;
  speCharPattern = /^[a-zA-Z\s.'\-,`]+$/;
  autoCorrect = false;
  public editForm: UntypedFormGroup = new UntypedFormGroup({
    ssn: new UntypedFormControl('', [Validators.required, Validators.pattern(/^(?!666|000\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/)]),
    firstName: new UntypedFormControl('', [Validators.required, Validators.pattern(this.speCharPattern)]),
    middleInitials: new UntypedFormControl(''),
    lastName: new UntypedFormControl('', [Validators.required, Validators.pattern(this.speCharPattern)]),
    addressLine1: new UntypedFormControl('', Validators.required),
    addressLine2: new UntypedFormControl(''),
    city: new UntypedFormControl('', [Validators.required, Validators.pattern(this.speCharPattern)]),
    state: new UntypedFormControl(''),
    zip: new UntypedFormControl('', Validators.required),
    zip4: new UntypedFormControl(''),
    departmentCode: new UntypedFormControl(''),
    locationCode: new UntypedFormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]),
    systemCode: new UntypedFormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]),
    payPeriodEndDate: new UntypedFormControl(''),
    actualAnnualCompensation: new UntypedFormControl(''),
    actualEarnableCompensation: new UntypedFormControl(''),
    employeeContribution: new UntypedFormControl('', Validators.required),
    payPeriodBaseSalary: new UntypedFormControl('', Validators.required),
    hoursWorked: new UntypedFormControl('', [Validators.required, Validators.min(0), Validators.max(288)]),
    standardHours: new UntypedFormControl('', Validators.required),
    percentFullTime: new UntypedFormControl('', [Validators.required, Validators.min(1), Validators.max(100)]),
    planCode: new UntypedFormControl(''),
    id: new UntypedFormControl(''),
    payrollImportId: new UntypedFormControl('')
  });
  @Input() isNew = false;
  @Input() userLocations: any[];
  @Input() systems: any[];

  @Input() orgId: number;
  @Input() set validationSetting(setting) {
    this.validationSettings = setting;
  }
  @Input() set model(record: any) {
    if (record) {
      this.editRecord(record);
    }
  }
  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() responseMsg: EventEmitter<any> = new EventEmitter();

  constructor(private importService: ImportService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    if (this.states === undefined) {
      this.loadStates();
    }
    const config = this.readConfigService.getPayrollUploadFile();
    this.invalidAAC = config.InvalidAAC;
    this.invalidAEC = config.InvalidAEC;
    this.invalidContribution = config.InvalidContribution;
    this.invalidPPBaseSalary = config.InvalidPPBaseSalary;
    this.invalidHoursWork = config.InvalidHoursWork;
    this.invalidStandardHours = config.InvalidStandardHours;
    this.invalidFTRange = config.InvalidFTRange;
    this.invalidFT = config.InvalidFT;
    this.errorAndIssueMsg = config.ErrorAndIssueMsg;
    this.continueMsg = config.ContinueMsg;
  }

  editRecord(record) {
    this.isNewRecord = this.isNew;
    this.recordIssues = [];
    this.recordErrors = [];
    this.isErr = false;
    this.isIssue = false;
    this.defaultState = { abbreviation: 'MD', name: 'Maryland' };
    if (record !== undefined && record.dataItem !== undefined) {
      if (record.dataItem.isError === 1) {
        this.isErr = true;
        this.recordErrors = record.dataItem.error.split(',');
      }
      if (record.dataItem.issue !== '') {
        this.isIssue = true;
        const issues = record.dataItem.issue.split(',');
        this.recordIssues = Utility.getIssues(issues);
      }
      const inputOrg = { id: record.dataItem.locationCode, name: record.dataItem.locationCode };
      this.defaultLocation = ((this.userLocations !== undefined) ?
        this.userLocations.filter(x => x.id === record.dataItem.locationCode)[0] :
        this.userLocations[0]) || inputOrg;
      let selectdSys: any;
      if (this.systems) {
        selectdSys = this.systems.filter(x => x.id === record.dataItem.systemCode);
      }
      this.defaultSystem = (selectdSys && selectdSys.length > 0) ? selectdSys[0] : this.defaultSysItem;
      // tslint:disable-next-line: max-line-length
      this.defaultState = (this.states === undefined) ? this.defaultState : this.states.filter(x => x.abbreviation === record.dataItem.state)[0];
      this.pped = new Date(record.dataItem.payPeriodEndDate).toLocaleDateString();
      this.importId = record.dataItem.payrollImportId;
      record.dataItem.systemCode = this.defaultSystem.id;
      record.dataItem.ssn = Utility.getIntegers(record.dataItem.ssn);
      record.dataItem.locationCode = Utility.getIntegers(record.dataItem.locationCode);
      this.editForm.reset(record.dataItem);
    } else {
      this.pped = new Date(record.PayPeriodEndDate).toLocaleDateString();
      if (this.userLocations !== undefined) {
        this.defaultLocation = this.defaultItem;
      }
      if (this.systems !== undefined) {
        this.defaultSystem = this.defaultSysItem;
      }
      if (record !== undefined) {
        record.actualAnnualCompensation = 0;
        record.actualEarnableCompensation = 0;
        record.employeeContribution = 0;
        record.payPeriodBaseSalary = 0;
        record.percentFullTime = 0;
        record.hoursWorked = this.min;
        record.standardHours = this.min;
        this.editForm.reset(record);
        this.importId = record.PayrollImportId;
      }
    }
    if (record !== undefined) {
      let val = this.validationSettings.find(s => s.keyName === 'HoursWorked').value;
      this.maxHW = parseFloat(val);
      val = this.validationSettings.find(s => s.keyName === 'StandardHours').value;
      this.maxSH = parseFloat(val);
      val = this.validationSettings.find(s => s.keyName === 'PayPeriodBaseSalary').value;
      this.maxPBS = parseFloat(val);
      val = this.validationSettings.find(s => s.keyName === 'EnrollmentDateCutOff').value;
      this.enrollmentDateCutoff = val;
    }
    if (this.maxAEC > 0) {
      const validators = [Validators.required, Validators.min(1), Validators.max(this.maxAEC)];
      this.editForm.get('actualAnnualCompensation').setValidators(validators);
      this.editForm.get('actualEarnableCompensation').setValidators(validators);
    }
    this.active = record !== undefined;
  }

  loadStates() {
    this.importService.getStates(true)
      .subscribe(states => {
        this.states = states;
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.notificationService.setErrorNotification();
        });
  }

  saveRecord(record: any): void {
    this.isProcessing = true;
    this.importService.save(record, this.isNewRecord)
      .subscribe(response => {
        this.responseMsg.emit(response);
        this.isErr = this.isIssue = false;
        this.active = response.success === false;
        if (this.active) {
          this.recordId = response.id;
          setTimeout(() => {
            this.isNewRecord = !this.active;
            if (response.result) {
              const issues = response.result.filter((x) => x.isError === false);
              const errors = response.result.filter((x) => x.isError === true);
              this.isErr = (errors && errors.length > 0);
              this.isIssue = (issues && issues.length > 0);
              if (this.isErr) {
                this.recordErrors = errors.map((x) => x.error);
              }
              if (this.isIssue) {
                this.recordIssues = Utility.getIssues(issues.map((x) => x.error));
                this.popUpIssues = issues.map((x) => x.error);
              }
            }
            this.displaySubmitPopUp = true;
          }, 250);
        }
        this.isProcessing = false;
      },
        (error: HttpErrorResponse) => {
          console.log(error);
          this.active = false;
          this.isProcessing = false;
          this.notificationService.setErrorNotification();
        }
      );
  }

  closePopup() {
    this.active = false;
    this.isProcessing = false;
  }

  trimContent(data: any) {
    if (data.target.value) {
      const replaceInput = data.target.value.replace(/[^a-zA-Z]/g, '');
      this.editForm.controls.middleInitials.setValue(replaceInput);
    }
  }

  onValueChanges(e, name) {
    this.editForm.controls[name].patchValue(e.id);
  }

  setIntMaxVal(name) {
    if (this.editForm.get(name).value) {
      let value = this.editForm.get(name).value.toString();
      if (value.length > this.charLimit) {
        value = value.substr(0, this.charLimit);
      }
      const setValue = parseInt(value);
      this.editForm.controls[name].setValue(setValue);
    }
  }

  setDecMaxVal(name) {
    if (this.editForm.get(name).value) {
      let value = this.editForm.get(name).value.toString();
      const char = name === 'employeeContribution' ? this.contrCharLimit : this.baseSalCharLimit;
      if (value.length > char) {
        value = value.substr(0, char);
        this.editForm.controls[name].setValue(parseFloat(value));
      }
    }
  }

  onSave(e: any): void {
    e.preventDefault();
    this.notificationService.setUpLoading(true);
    const record = this.editForm.value;
    if (this.isNew && this.isNewRecord) {
      const stagingRecord = new StagingPayrollRecord();
      stagingRecord.FirstName = record.firstName;
      stagingRecord.LastName = record.lastName;
      stagingRecord.SSN = record.ssn;
      stagingRecord.AddressLine1 = record.addressLine1;
      stagingRecord.City = record.city;
      stagingRecord.State = this.defaultState.abbreviation;
      stagingRecord.Zip = record.zip;
      stagingRecord.MiddleInitials = record.middleInitials === null ? '' : record.middleInitials;
      stagingRecord.AddressLine2 = record.addressLine2 === null ? '' : record.addressLine2;
      stagingRecord.Zip4 = record.zip4 === null ? '' : record.zip4;
      stagingRecord.DepartmentCode = record.departmentCode === null ? '' : record.departmentCode;
      stagingRecord.PlanCode = '';
      stagingRecord.ActualAnnualCompensation = record.actualAnnualCompensation;
      stagingRecord.ActualEarnableCompensation = record.actualEarnableCompensation;
      stagingRecord.EmployeeContribution = record.employeeContribution;
      stagingRecord.HoursWorked = record.hoursWorked;
      stagingRecord.PayPeriodBaseSalary = record.payPeriodBaseSalary;
      stagingRecord.PayPeriodEndDate = this.pped;
      stagingRecord.StandardHours = record.standardHours;
      stagingRecord.LocationCode = this.defaultLocation.id;
      stagingRecord.SystemCode = this.defaultSystem.id;
      stagingRecord.PercentFullTime = record.percentFullTime;
      stagingRecord.PayrollImportId = this.importId;
      this.saveRecord(stagingRecord);
    } else {
      record.id = (record.id ? record.id : this.recordId);
      record.middleInitials = record.middleInitials === null ? '' : record.middleInitials;
      record.addressLine2 = record.addressLine2 === null ? '' : record.addressLine2;
      record.zip4 = record.zip4 === null ? '' : record.zip4;
      record.departmentCode = record.departmentCode === null ? '' : record.departmentCode;
      record.planCode = '';
      record.payrollImportId = (record.payrollImportId ? record.payrollImportId : this.importId);
      record.payPeriodEndDate = new Date(this.pped);
      record.locationCode = this.defaultLocation.id;
      record.systemCode = this.defaultSystem.id;
      record.state = this.defaultState.abbreviation;
      this.saveRecord(record);
    }
  }

  onCancel(e: any): void {
    e.preventDefault();
    this.closeForm();
  }

  closeForm(): void {
    this.displaySubmitPopUp = false;
    this.active = false;
    this.cancel.emit();
  }

}
